import React from "react";
import { Tile } from "./Tile";

export interface OpponentBadgeProps {
  name: string;
  cardsRemaining: number;
  wins: number;
  isCurrentTurn: boolean;
  orientation: "top" | "left" | "right";
  size: number;
}

export const OpponentBadge: React.FC<OpponentBadgeProps> = ({
  name,
  cardsRemaining,
  wins,
  isCurrentTurn,
  orientation,
  size,
}) => {
  const tiles = [];
  for (let i = 0; i < cardsRemaining; i++) {
    tiles.push(
      <Tile
        key={i}
        card={29}
        size={size}
        orientation="back"
      />
    );
  }
  // For left/right opponents, stack tiles vertically (rotated visual).
  const flexDir = orientation === "top" ? "row" : "column";
  return (
    <div
      style={{
        display: "flex",
        flexDirection: orientation === "top" ? "column" : "row",
        alignItems: "center",
        gap: 6,
        padding: 6,
        background: isCurrentTurn ? "rgba(254,209,0,0.18)" : "rgba(0,0,0,0.25)",
        border: isCurrentTurn ? "2px solid #FED100" : "2px solid transparent",
        borderRadius: 10,
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          color: "#fff",
          fontSize: 12,
          fontWeight: 600,
          textAlign: "center",
          minWidth: 40,
          padding: "2px 6px",
          background: "rgba(0,0,0,0.35)",
          borderRadius: 6,
        }}
      >
        {name} · {wins}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: flexDir,
          gap: 3,
          alignItems: "center",
          justifyContent: "center",
          flexWrap: "nowrap",
        }}
      >
        {tiles.length > 0 ? (
          tiles
        ) : (
          <div style={{ color: "#cfead4", fontSize: 11, opacity: 0.7 }}>—</div>
        )}
      </div>
    </div>
  );
};
